/**
 * Utility Object that contains common functions
 * @type Object
 */
import $ from 'jquery'
import { getEnv } from 'aria-viewer/utils/environment'

var Utils = {
    getParameterByName: function(name) {
        name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]')
        var regex = new RegExp('[\\?&]' + name + '=([^&#]*)'),
            results = regex.exec(location.search)
        return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '))
    },

    removeParameterByName: function(name) {
        var url = window.location.search.slice(window.location.search.indexOf('?') + 1).split('&')
        var list = []
        for (var i = 0; i < url.length; i++) {
            var urlparam = url[i].split('=')
            if (urlparam[0] != name) {
                list.push(urlparam[0] + '=' + urlparam[1])
            }
        }

        url = window.location.href.split('?')[0]
        for (var i = 0; i < list.length; i++) {
            url += (i == 0 ? '?' : '&') + list[i]
        }

        return url
    },

    getCookie: function(sKey) {
        if (!sKey) {
            return null
        }
        return (
            decodeURIComponent(
                document.cookie.replace(
                    new RegExp(
                        '(?:(?:^|.*;)\\s*' +
                            encodeURIComponent(sKey).replace(/[\-\.\+\*]/g, '\\$&') +
                            '\\s*\\=\\s*([^;]*).*$)|^.*$'
                    ),
                    '$1'
                )
            ) || null
        )
    },

    generateID: function() {
        var id
        do {
            id = Math.round(Math.random() * 1e16)
        } while (id < 1e15)
        return id
    },

    /**
     * Generate youvis.it TinyURL
     * @param  string url to tiny-fiy
     * @param  callback cb callback to call on success
     * @return boolean 	if ajax request was started
     */
    generateTinyURL: function(url, cb) {
        var scope = this
        if (typeof url === undefined || typeof cb === undefined) {
            return false
        }
        this._tinyURLCache = this._tinyURLCache || {}
        if (url in this._tinyURLCache) {
            cb(this._tinyURLCache[url])
        } else {
            $.ajax({
                method: 'POST',
                dataType: 'json',
                type: 'application/json',
                url: `${getEnv('REACT_APP_BASE_URL')}/main/Home/generateTinyURL?t=${Date.now()}`,
                data: {
                    url: url,
                    requestid: Utils.generateID(),
                },
                success: function(response) {
                    if (response.success && typeof response.data.url === 'string') {
                        scope._tinyURLCache[url] = response.data.url
                        cb(response.data.url)
                    } else {
                        console.error(response.message)
                    }
                },
            })
        }
        return true
    },
}
export default Utils
